import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];

export default function Practices() {
  const { t } = useI18n();

  return (
    <section
      id="practice"
      className="section border-t hair"
      data-testid="practices-section"
    >
      <div className="container-edge">
        <SectionHead
          roman={t.sections.practice.roman}
          right={
            <span className="mono" style={{ color: "var(--faded)" }}>
              ten habits
            </span>
          }
        />

        {/* heading + sub */}
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10 mb-24 md:mb-40">
          <motion.h2
            className="col-span-12 md:col-span-7 display text-[40px] sm:text-[56px] md:text-[72px] lg:text-[92px] whitespace-pre-line"
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease }}
            data-testid="practices-heading"
          >
            {t.practice.heading}
          </motion.h2>

          <motion.p
            className="col-span-12 md:col-span-4 md:col-start-9 body-text self-end"
            style={{ maxWidth: "36ch" }}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
          >
            {t.practice.sub}
          </motion.p>
        </div>

        {/* catalogue */}
        <div className="border-t hair" data-testid="practice-list">
          {t.practice.items.map((item, idx) => (
            <motion.article
              key={item.n}
              className="practice-row border-b hair grid grid-cols-12 gap-4 md:gap-10 py-10 md:py-14"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease, delay: idx * 0.04 }}
              data-testid={`practice-item-${idx + 1}`}
            >
              {/* number */}
              <div className="col-span-2 md:col-span-1">
                <span className="mono" style={{ color: "var(--faded)" }}>
                  {item.n}
                </span>
              </div>

              {/* title + body */}
              <div className="col-span-10 md:col-span-7">
                <h3
                  className="display text-[24px] sm:text-[30px] md:text-[38px] lg:text-[44px] mb-5 md:mb-6"
                  style={{ fontWeight: 400 }}
                >
                  {item.title}
                </h3>
                <p className="body-text" style={{ maxWidth: "56ch" }}>
                  {item.body}
                </p>
              </div>

              {/* spec column — keep method/frequency annotations, drop item code */}
              <div className="col-span-12 md:col-span-3 md:col-start-10 mt-2 md:mt-2 flex flex-col gap-2">
                {item.spec.map((s, i) => (
                  <span key={i} className="mono" style={{ color: "var(--faded)" }}>
                    — {s}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
